import api from './utils/api';

class AdsService {
  async listAds(body) {
    let url = '/ads';

    if (body) {
      url = `/ads?body=${body}`;
    }

    const result = await api.get(url);
    return result.data;
  }

  async create(data) {
    const result = await api.post('/ads', data);
    return result.data;
  }

  async updateLink(data) {
    const result = await api.put('/ads', data);
    return result.data;
  }

  async delete(id) {
    const result = await api.delete(`/ads/${id}`);
    return result.data;
  }
}

export default new AdsService();
